import { PlatformEnvironment } from '@mews/enums';

/** Matches app.mews-$ENV.com or app.mews.com or services.mews.com or cdn.mews.com.... etc...  */
export const ANY_MEWS_URL = new RegExp(/^https?:\/\/[^/?]*\.mews(-[^/?]*)?\.com(?:[/?#]|$)/);

export const CORALOGIX_DOMAIN = 'EU2';

/**
 * Data attribute used to mark elements that should not be masked in Coralogix session recordings.
 * Add this attribute to elements whose text content should remain visible in session replays.
 *
 * **WARNING**: This will unmask data in session recordings. Be careful when using this attribute
 * to avoid leaking any PII (Personally Identifiable Information) or sensitive data.
 * Only use on elements containing non-sensitive, static content.
 *
 * @example
 * <span data-non-sensitive>Visible text</span>
 */
export const OBSERVABILITY_UNMASK_ATTRIBUTE = 'data-non-sensitive';

/**
 * Data attribute used to mark elements that should be blocked in Coralogix session recordings.
 * Add this attribute to elements that cause security errors or contain sensitive content that cannot be masked.
 *
 * @example
 * <iframe data-block-observability src="...creditCardProvider..." />
 */
export const BLOCK_OBSERVABILITY_ATTRIBUTE = 'data-block-observability';

export const DEPLOYMENT_ENVIRONMENT = {
    [PlatformEnvironment.Development]: 'dev',
    [PlatformEnvironment.Demo]: 'demo',
    [PlatformEnvironment.Production]: 'prod',
    [PlatformEnvironment.Test]: 'test',
};

export const CORALOGIX_PUBLIC_KEYS = {
    [PlatformEnvironment.Development]: 'cxtp_JUD4OgoUmrkWi20fCeQAHVqyQaE8uc',
    [PlatformEnvironment.Demo]: 'cxtp_7OipVstMWySJRZ9yn9F7vcJjKGnxei',
    [PlatformEnvironment.Production]: 'cxtp_LSX5IOzXSb9t6Sf9lplGILt4zDG67O',
    [PlatformEnvironment.Test]: 'cxtp_NNQAqRoaWra9ovM9iVFoCQEADtpojC',
};
